import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "badgeList", "pickerInput", "badgeTemplate" ]

  addFromPicker(event) {
    event.preventDefault()

    const select = this.pickerInputTarget
    const profileId = select.value
    if (!profileId) return

    const existing = this.badgeListTarget.querySelectorAll(".js-labor-profile-id")
    for (const input of existing) {
      if (input.value === profileId) return
    }

    const label = select.options[select.selectedIndex].text
    const html = this.badgeTemplateTarget.innerHTML.trim()

    const wrapper = document.createElement("div")
    wrapper.innerHTML = html
    const badge = wrapper.firstElementChild

    badge.querySelector(".js-labor-profile-id").value = profileId
    badge.querySelector(".labor-badge-label").textContent = label

    this.badgeListTarget.appendChild(badge)
    select.selectedIndex = 0
  }

  removeBadge(event) {
    event.preventDefault()
    const badge = event.target.closest("[data-labor-badge]")
    if (badge) badge.remove()
  }
}
